import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import * as Ant from 'antd';
import * as AppActions from '../../AppActions';

const F = AppActions.F;

export default function TeamStaffList(props) {
  const [locale, setLocale] = useOutlet('locale');
  const lang = locale.lang;
  const {data} = props;

  if (!data) {
    return <Wrapper />;
  }

  return (
    <Wrapper>
      <div className="title">
        <h2>{F(data, 'title')}</h2>
      </div>
      <div className="container">
        <Ant.Descriptions bordered column={1}>
          {Array.isArray(data.groups) &&
            data.groups.length > 0 &&
            data.groups.map((it, index) => {
              if (it.is_only_tw && lang !== 'tw') {
                return null;
              }
              return (
                <Ant.Descriptions.Item
                  label={<span className="group-label">{F(it, 'name')}</span>}
                  children={
                    <div className="group-grid">
                      {it.list?.map((person, idx) => {
                        if (person.name.length >= 16) {
                          return (
                            <div className="item wide">{F(person, 'name')}</div>
                          );
                        }

                        return <div className="item">{F(person, 'name')}</div>;
                      })}
                    </div>
                  }
                />
              );
            })}
        </Ant.Descriptions>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 60px;

  & > .title {
    margin-top: 10px;
    margin-bottom: 15px;
  }

  & > .container {
  }

  .group-label {
    display: block;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 0.95rem;
  }

  .group-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    & > .item {
      border-right: 1px solid #ccc;
      margin: 8px 0px;
      padding: 0px 5px;
      word-break: break-word;
      padding: 0px 10px;
      font-size: 0.95rem;

      &.wide {
        grid-column: 1 / -1;
        text-align: left;
        border: none;
      }
    }

    & > .item:nth-child(3n),
    & > .item:last-child {
      border-right: none;
    }

    @media screen and (max-width: 600px) {
      grid-template-columns: repeat(2, 1fr);

      & > .item:nth-child(3n) {
        border-right: 1px solid #ccc;
      }

      & > .item:nth-child(2n),
      & > .item:last-child {
        border: none;
      }
    }

    @media screen and (max-width: 500px) {
      grid-template-columns: repeat(1, 1fr);

      & > .item {
        padding: 0px;
      }

      & > .item:nth-child(2n) {
        border-right: 1px solid #ccc;
      }

      & > .item:nth-child(1n),
      & > .item:last-child {
        border: none;
      }
    }
  }
`;
